<section class="recommendations"
  [class.recommendations--sidebar]="isSidebar()"
  [class.recommendations--bottom]="!isSidebar()"
  i18n-aria-label="@@einvoice.recommendations.label"
  aria-label="Recommendations">
  @if (!isSidebar()) {
    <button type="button" class="toggle"
      [attr.aria-expanded]="expanded()"
      aria-controls="recommendation-entries"
      (click)="toggle()">
      <span i18n="@@einvoice.recommendations.label">Recommendations</span>
      <mat-icon class="toggle__icon" [class.toggle__icon--open]="expanded()" svgIcon="expand_more" aria-hidden="true"></mat-icon>
    </button>
  }
  <div id="recommendation-entries" class="content" [hidden]="!isSidebar() && !expanded()">
    <ul class="entries">
      @for (entry of entries; track entry.id; let first = $first) {
        <li class="entry" [class.entry--highlight]="first">
          <a class="entry__headline" [href]="entry.href" target="_blank" rel="noopener"
            (click)="onOpen(entry, $event)" (auxclick)="onOpen(entry, $event)">{{ entry.headline }}</a>
          <span class="entry__domain">{{ entry.domain }}</span>
          <p class="entry__description">{{ entry.description }}</p>
        </li>
      }
    </ul>
    <button type="button" class="cookie-settings" (click)="openCookieSettings()" i18n="@@consent.settings.label">Cookie Settings</button>
  </div>
</section>
